import { Fragment } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../Components/checkoutPageComponent/checkoutForm";
import SDK from "../config";
import { images } from "../Constants/imageslinks.js";
import Header from "../Components/ui/header.jsx";
import MenuComponent from "../Components/reservationPageComponents/menuComponent.jsx";
import Footer from "../Components/ui/footer.jsx";

// const stripePromise = loadStripe(SDK.STRIPE_KEY);
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY_LIVE);

const CheckOutPage = () => {
  return (
    <Elements stripe={stripePromise}>
      <Fragment>
        <div>
          <div className="bg-primary200">
            <div className="lg:hidden">
              <Header />
            </div>
            <div className="block lg:hidden bg-primary100 md:px-8 px-4 pb-4 pt-5 md:pt-0">
              <div className="sm:ml-7 ml-3 flex items-center justify-start">
                <img src={images.early_access_icon} alt="deposit icon" />

                <div className="sm:w-[122px] w-[110px] h-0.5 bg-secondary100" />

                <img src={images.checkout_icon} alt="payment icon" />

                <div className="sm:w-[122px] w-[110px] h-[1px] bg-primary500/20" />

                <img src={images.confirmation_icon} alt="confirm icon" />
              </div>

              <div className="flex gap-22 relative mt-2 sm:ml-6 ml-3 justify-start">
                <p className="font-inter font-light text-sm leading-3.5 whitespace-nowrap	">
                  Start
                </p>
                <p className="font-inter font-medium text-sm leading-3.5 sm:ml-[113px] ml-[100px]">
                  Active
                </p>
                <p className="font-inter font-light text-sm leading-3.5 text-dark-100 sm:ml-[87px] ml-[78px]">
                  Confirmation
                </p>
              </div>
            </div>
            <div className="3xl:container 3xl:mx-auto bg-primary300 lg:grid grid-cols-12 flex flex-col-reverse">
              <div className="lg:min-h-screen lg:px-[7vw] md:px-8 px-4 3xl:px-[110px] col-span-7">
                <div className="py-[45px] hidden lg:block">
                  <img src={images.minimis_logo} alt="minimis logo" />
                </div>

                <div className="lg:block hidden">
                  <div className=" ml-7 flex items-center justify-start">
                    <img src={images.early_access_icon} alt="deposit icon" />

                    <div className="lg:w-[122px] md:w-[100px] w-[60px] h-0.5 bg-secondary100" />

                    <img src={images.checkout_icon} alt="payment icon" />

                    <div className="w-[122px] h-[1px] bg-primary500/20" />

                    <img src={images.confirmation_icon} alt="confirm icon" />
                  </div>

                  <div className="flex gap-22 relative mt-2 ml-[22px] justify-start">
                    <p className="font-inter font-light text-sm leading-3.5 text-secondary100">
                      Start
                    </p>
                    <p className="font-inter font-medium text-sm leading-3.5 ml-[115px] text-secondary100">
                      Active
                    </p>
                    <p className="font-inter font-light text-sm leading-3.5 text-dark-100 ml-[88px] text-secondary100/70">
                      Confirmation
                    </p>
                  </div>
                </div>

                <CheckoutForm />
              </div>

              <div className="col-span-5 bg-primary200 flex justify-center items-start lg:pt-12 pt-16">
                <img
                  src={images.hero_image}
                  alt="hero image"
                  className="w-full max-w-[480px]"
                />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </Fragment>
    </Elements>
  );
};

export default CheckOutPage;
